import './App.css';
import Form from './components/common/Form';
import {
	Routes,
	Route,
	useNavigate
} from 'react-router-dom';
import {useState, useEffect} from 'react';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme'
import { db } from './firebase-config';
import { getAuth, signInWithEmailAndPassword,createUserWithEmailAndPassword } from 'firebase/auth';
import { collection, getDocs, setDoc, doc } from 'firebase/firestore';
import Home from './components/Home';
import Here from './components/Here';


function App() {
  const [users,setUsers] = useState('');
  const [email,setEmail] = useState('');
  const [password,setPassword] = useState('');
  const [errorMessage,setErrorMessage] = useState('user Email Not Registered');
  
  const userCollectionRef = collection(db, "users");
  
  let navigate = useNavigate();
  

  
  useEffect(() => {
	  let authToken = sessionStorage.getItem("Auth Token")
	  
	  const getUsers = async () => {
		  const data = await getDocs(userCollectionRef);
		  console.log()
		  setUsers(data.docs.map((doc) => ({...doc.data(), id:doc.id})));
	  }
	  
	  getUsers();
	  if(authToken){
		  navigate('/home')
	  }
  }, [])
  
  const handleAction = (id) => {
	  const authentication = getAuth();
	  
	  if(id === 2){
		
		createUserWithEmailAndPassword(authentication, email, password)
		.then((response) => {
			
			const user = response.user;
			
			const createusers = async () => {
				await setDoc(doc(db, "users", user.uid), {
					name: email, 
					bio: "", 
					location: "", 
					website: ""
					});
			}
			
			createusers();
			
			navigate('/home');
			sessionStorage.setItem('Auth Token',
			response._tokenResponse.refreshToken)
		})
		.catch((error) => {
			const errorCode = error.code;
			setErrorMessage(error.message);
			alert(errorCode,errorMessage);
		});
	  }
	  
	  if(id === 1){
		signInWithEmailAndPassword(authentication, email, password)
		.then((response) => {
			const user = response.user;
			console.log(user.uid)
			navigate('/home')
			sessionStorage.setItem('Auth Token',
			response._tokenResponse.refreshToken)
		})
		.catch((error) => {
			const errorCode = error.code;
			setErrorMessage(error.message);
			alert(errorCode,errorMessage);
		});
		
	  }
  }
  
  return (
	<>
	<ThemeProvider theme={theme}>
		<div className="App">
			<>
				<Routes>
					<Route path='/' element={<Here title="Login" setEmail={setEmail} setPassword={setPassword} handleAction={() => handleAction(1)} />} />
					<Route path='/register' element={<Form title="Register" setEmail={setEmail} setPassword={setPassword} handleAction={() => handleAction(2)} />} />
					<Route path='/*' element={<Home/>} />
				</Routes>
			</>
		</div>
	</ThemeProvider>
	</>
  );
}

export default App;
